<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addProject"
            >添加缴费项目</el-button
          >
        </div>
        <div class="header-right">
          <div style="margin-right: 10px">
            <span>缴费机构：</span>
            <el-select
              v-model="lifePayInstitutionId"
              size="small"
              placeholder="请选择缴费机构"
            >
              <el-option
                v-for="item in lifePayInstitutions"
                :key="item.lifePayInstitutionId"
                :label="item.institutionName"
                :value="item.lifePayInstitutionId"
              >
              </el-option>
            </el-select>
          </div>
          <el-radio-group size="small" v-model="payStatus">
            <el-radio-button :label="-1">全部</el-radio-button>
            <el-radio-button :label="1">正常</el-radio-button>
            <el-radio-button :label="0">已暂停</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="tab-content">
        <div class="list" v-if="lifePayInstitutions.length">
          <el-table :data="projectList" style="width: 100%">
            <el-table-column label="缴费机构">
              <template slot-scope="scope">
                <div class="name">
                  {{
                    lifePayInstitutionsObj[scope.row.lifePayInstitutionId].institutionName
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="缴费项目（缴费批次）" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.lifePayBatchName }}({{ scope.row.lifePayBatchId }})
                </div>
              </template>
            </el-table-column>
            <el-table-column label="缴费时间段" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.payStartTime.split(" ")[0] }}~{{
                    scope.row.payEndTime.split(" ")[0]
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.isEnable == 1 ? "正常" : "已暂停" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="small"
                    :type="scope.row.isEnable == 1 ? 'danger' : 'success'"
                    @click="updatedLifePayBatchEnable(scope.row)"
                    plain
                    >{{ scope.row.isEnable == 1 ? "暂停" : "启用" }}</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    v-if="scope.row.lifePayInstitutionType != 300"
                    @click="edit(scope.$index)"
                    plain
                    >修改</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="linkToBill(scope.row)"
                    plain
                    >缴费列表</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogCreateProjectVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="540px"
    >
      <div slot="title" class="dialog-title">
        {{ createProjectForm.lifePayBatchId ? "编辑缴费项目" : "新建缴费项目" }}
      </div>
      <el-form
        :model="createProjectForm"
        :rules="createProjectFormRule"
        ref="createProjectForm"
        label-width="128px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
      >
        <el-form-item label="缴费机构" prop="lifePayInstitutionId">
          <el-select
            v-model="createProjectForm.lifePayInstitutionId"
            size="small"
            placeholder="请选择缴费机构"
          >
            <el-option
              v-for="item in addLifePayInstitutions"
              :key="item.lifePayInstitutionId"
              :label="item.institutionName"
              :value="item.lifePayInstitutionId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缴费项目" prop="lifePayBatchName">
          <el-input
            v-model.trim="createProjectForm.lifePayBatchName"
            placeholder="请输入缴费项目"
          ></el-input>
        </el-form-item>
        <el-form-item label="缴费时间" prop="payStartTime">
          <el-date-picker
            v-model="payTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="自定义" v-show="!createProjectForm.lifePayBatchId">
          <el-radio-group v-model="createProjectForm.isCustomInfo">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div v-show="createProjectForm.isCustomInfo">
            <el-input
              v-model.trim="createProjectForm.customInfoName01"
              placeholder="自定义1"
            ></el-input>
            <el-input
              v-model.trim="createProjectForm.customInfoName02"
              placeholder="自定义2"
            ></el-input>
          </div>
        </el-form-item>
        <el-form-item label="缴费列表" prop="lifePayFileName">
          <div class="xls-row">
            <el-upload
              class="upload-xls"
              action="/edcmanageapi/LifePay_uploadExcel"
              :http-request="uploadXls"
              :show-file-list="false"
              accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
              <el-button :loading="isUpload" type="primary" size="small"
                >上传缴费列表</el-button
              >
            </el-upload>
            <el-link
              type="primary"
              class="fix-middle"
              :underline="false"
              @click="exportXlsTemplate"
            >
              <i class="iconfont iconxiazai-copy"></i>下载模板
            </el-link>
          </div>
          <div>{{ createProjectForm.lifePayFileName }}</div>
        </el-form-item>
      </el-form>
      <div class="tips" v-if="!createProjectForm.lifePayBatchId">
        <p>1.自定义为导入模板新增的可编辑字段</p>
        <p>2.自定义输入字段不能与导入列表其他字段重复</p>
        <p>3.一次最多导入5000条数据</p>
      </div>
      <div class="tips" v-if="createProjectForm.lifePayBatchId">
        <p>一次最多导入5000条数据</p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createProject" :loading="isSubmit">{{
          createProjectForm.lifePayBatchId ? "立即编辑" : "立即创建"
        }}</el-button>
        <el-button @click="dialogCreateProjectVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLifePayBatchList,
  getLifePayBatchListtCount,
  getLifePayInstitutions,
  updatedLifePayBatchEnable,
  getLifePayInstitutionQrCode,
  addLifePayBatch,
  updateLifePayBatch,
  uploadExcel,
} from "@/api/index.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      payStatus: -1,
      lifePayInstitutionId: "",
      lifePayInstitutions: [],
      addLifePayInstitutions: [],
      lifePayInstitutionsObj: {},
      projectList: [],
      selCard: "",
      pageSize: 10,
      pageCount: 0,
      pageNo: 1,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogCreateProjectVisible: false,
      payTime: "",
      createProjectForm: {
        lifePayInstitutionId: "",
        lifePayBatchName: "",
        payStartTime: "",
        payEndTime: "",
        isCustomInfo: 1,
        customInfoName01: "",
        customInfoName02: "",
        lifePayFileName: "",
      },
      createProjectFormRule: {
        lifePayBatchName: [
          {
            required: true,
            message: "请填写缴费项目",
            trigger: "blur",
          },
        ],
        lifePayInstitutionId: [
          {
            required: true,
            message: "请选择缴费机构",
            trigger: "blur",
          },
        ],
        payStartTime: [
          {
            required: true,
            message: "请选择缴费时间",
            trigger: "blur",
          },
        ],
      },
      isSubmit: false,
      isUpload: false,
    };
  },
  components: {},
  watch: {
    lifePayInstitutionId(val) {
      this.getPageData();
    },
    payStatus(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    payTime(val) {
      console.log(val, new Date(val[0]).format("yyyy-MM-dd"));
      this.createProjectForm.payStartTime = new Date(val[0]).format("yyyy-MM-dd");
      this.createProjectForm.payEndTime = new Date(val[1]).format("yyyy-MM-dd");
    },
  },
  mounted() {
    if (this.$route.query.type == "addvip") {
      this.addProject();
    }
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getLifePayBatchList();
      this.getLifePayBatchListtCount();
    },
    getLifePayBatchList() {
      getLifePayBatchList({
        pageNo: this.pageNo,
        row: this.pageSize,
        lifePayInstitutionId: this.lifePayInstitutionId,
        isEnable: this.payStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.projectList = res.data;
        }
        if (!this.lifePayInstitutions.length) {
          this.getLifePayInstitutions();
        }
        if (res.code == -1) {
          this.projectList = [];
        }
      });
    },
    getLifePayBatchListtCount() {
      getLifePayBatchListtCount({
        lifePayInstitutionId: this.lifePayInstitutionId,
        isEnable: this.payStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    getLifePayInstitutions() {
      getLifePayInstitutions({
        row: 1000,
        pageNo: 1,
      }).then((res) => {
        if (res.code == 1) {
          let data = JSON.parse(JSON.stringify(res.data));
          this.addLifePayInstitutions = res.data;
          data.unshift({
            institutionName: "全部",
            lifePayInstitutionId: "",
          });
          res.data.forEach((val) => {
            this.lifePayInstitutionsObj[val.lifePayInstitutionId] = val;
          });
          this.lifePayInstitutions = data;
          this.$forceUpdate();
        }
        if (res.code == -1) {
          this.lifePayInstitutions = [];
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getLifePayBatchList();
    },
    updatedLifePayBatchEnable(row) {
      updatedLifePayBatchEnable({
        lifePayBatchId: row.lifePayBatchId,
        isEnable: row.isEnable == 1 ? 0 : 1,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          row.isEnable = row.isEnable == 1 ? 0 : 1;
        }
      });
    },
    showQrcode(row) {
      console.log(
        getLifePayInstitutionQrCode({
          lifePayInstitutionId: row.lifePayInstitutionId,
        })
      );
      this.dialogImageUrl = getLifePayInstitutionQrCode({
        lifePayInstitutionId: row.lifePayInstitutionId,
      });
      setTimeout(() => {
        this.dialogVisible = true;
      }, 500);
    },
    edit(index) {
      let params = JSON.parse(JSON.stringify(this.createProjectForm));
      let projectList = JSON.parse(JSON.stringify(this.projectList[index]));
      console.log(projectList);
      Object.assign(params, projectList);
      this.payTime = [new Date(params.payStartTime), new Date(params.payEndTime)];
      this.createProjectForm = params;
      console.log(this.createProjectForm, this.payTime);
      this.addProject();
    },
    dialogClose() {
      this.createProjectForm = {
        lifePayInstitutionId: "",
        lifePayBatchName: "",
        payStartTime: "",
        payEndTime: "",
        isCustomInfo: 1,
        customInfoName01: "",
        customInfoName02: "",
        lifePayFileName: "",
      };
      this.payTime = [];
      this.$refs.createProjectForm.resetFields();
    },
    addProject() {
      this.dialogCreateProjectVisible = true;
    },
    createProject() {
      this.$refs.createProjectForm.validate((valid) => {
        if (valid) {
          this.isSubmit = true;
          let params = JSON.parse(JSON.stringify(this.createProjectForm));
          if (!params.lifePayBatchId) {
            if (this.isUpload) {
              this.$notify({
                title: "提示",
                message: "文件上传中",
                type: "warning",
                duration: 2000,
              });
              this.isSubmit = false;
              return;
            }
            if (!this.createProjectForm.lifePayFileName) {
              this.$notify({
                title: "提示",
                message: "请上传文件",
                type: "warning",
                duration: 2000,
              });
              this.isSubmit = false;
              return;
            }
            addLifePayBatch(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: params.lifePayBatchId ? "编辑成功" : "创建成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.dialogCreateProjectVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          } else {
            params.time = Math.random();
            updateLifePayBatch(params).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: params.lifePayBatchId ? "编辑成功" : "创建成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
                this.dialogCreateProjectVisible = false;
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
              setTimeout(() => {
                this.isSubmit = false;
              }, 500);
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    uploadXls(item) {
      if (!~item.file.name.indexOf(".xls")) {
        this.$notify({
          title: "警告",
          message: "请上传xls格式文件",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      this.isUpload = true;
      let sessionId = localStorage.getItem("sessionId");
      let userId = localStorage.getItem("userId");
      let imgUploadForm = new FormData();
      imgUploadForm.append("file", item.file);
      imgUploadForm.append("fileContentType", item.file.type);
      imgUploadForm.append("fileFileName", item.file.name);
      imgUploadForm.append("userId", userId);
      imgUploadForm.append("sessionId", sessionId);
      uploadExcel(imgUploadForm).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "导入成功",
            type: "success",
            duration: 2000,
          });
          this.isUpload = false;
          this.createProjectForm.lifePayFileName = res.data.fileName;
        }
        if (res.code == 0) {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    exportXlsTemplate() {
      if (this.createProjectForm.isCustomInfo) {
        location.href = `${request.baseUrl}/download/缴费模板V4.xlsx`;
      } else {
        location.href = `${request.baseUrl}/download/缴费模板V3.xlsx`;
      }
    },
    linkToBill(row) {
      this.$router.push({
        name: "payManageBill",
        params: {
          lifePayBatchId: row.lifePayBatchId,
          lifePayInstitutionId: row.lifePayInstitutionId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
    .template-name {
      color: #66b1ff;
    }
    .status {
      display: inline-block;
      width: 70px;
      margin-right: 5px;
      &.ing {
        color: #ffaa00;
      }
      &.suc {
        color: #7abd54;
      }
      &.fail {
        color: #ff4c4c;
      }
    }
  }
  .el-cascader {
    width: 100%;
  }
  .tips {
    border: 1px solid #ff9191;
    background-color: #ffe6e6;
    display: block;
    position: relative;
    color: #666;
    font-size: 12px;
    line-height: 30px;
    padding: 8px;
    border-radius: 3px;
    .em {
      color: #3388ff;
    }
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.el-input + .el-input {
  margin-top: 10px;
}
.xls-row {
  display: flex;
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>
